var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("toolbar", {
        staticClass: "Home__PageTeller",
        attrs: { title: _vm.pageName },
        on: { TOGGLE_SIDEBAR: _vm.toggleSidenav }
      }),
      _vm._v(" "),
      _c("mediaItemUploading", {
        style: { opacity: _vm.videoUploadingComponentOpacity },
        on: { showVideoUploading: _vm.showMediaItemUploadingComponent }
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-fade", mode: "out-in" } },
        [_c("router-view", { staticClass: "layout-content" })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31894663", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31894663","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/Home.vue
// module id = 632
// module chunks = 0